import { render, staticRenderFns } from "./JobAppointmentDetails.vue?vue&type=template&id=6ffdb35c"
import script from "./JobAppointmentDetails.vue?vue&type=script&lang=js"
export * from "./JobAppointmentDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports